/**
 * @name News
 * @description Componente que muestra los avisos de la empresa
 * @author Ricardo Guerra
 */

import React, { PureComponent } from 'react';
import i18n from 'i18next';
import { Trans } from 'react-i18next';
import moment from 'moment';
import styled from 'styled-components';

import { NewsService, ResponseHandlerService } from '@services';
import { Card, Icons, MUI, Typography } from '@styles';

import NewsDialog from '../dialogs/news.dialog';

import { trackPromise } from 'react-promise-tracker';

class News extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      newsData: [],
      open: false,
      filters: {
        read: false
      }
    };
  }

  componentDidMount() {
    const { filters } = this.state;
    this.getNews(filters);
  }

  getNews = (filters) => {
    trackPromise(
      NewsService.getByUser({ filter: { leido: filters.read } })
        .then((data) => {
          let toDelete = data.length > 3 ? data.length - 3 : 0; // Número de elementos del array a eliminar
          data.splice(0, toDelete); // Dejar sólo 3 elementos
          this.setState({ newsData: data });
        })
        .catch((error) => {
          ResponseHandlerService.error(error);
          this.setState({ newsData: [] });
        }),
      'loading-datagrid'
    );
  }

  filterNews = (filters) => {
    this.getNews(filters);
    this.setState({ filters });
  }

  clickRow = (row) => {
    const { filters } = this.state;

    let advice = row[0];
    advice.Leido = !advice.Leido;
    NewsService.markAsRead(advice)
      .then((response) => {
        ResponseHandlerService.success(response);
        this.getNews(filters);
      })
      .catch((error) => {
        ResponseHandlerService.error(error);
      });
  }

  openDialog = () => {
    this.setState({ open: true });
  }

  closeDialog = () => {
    this.setState({ open: false });
  }

  render() {
    const {
      newsData,
      filters,
      open
    } = this.state;

    return (
      <>
        <Card.Header divider>
          <Card.HeaderTitle>
            <Typography.H5>{i18n.t('News.news')}</Typography.H5>
          </Card.HeaderTitle>
          <Card.HeaderAction>
            <MUI.Tooltip title={<Trans>GenericMessages.seeAll</Trans>}>
              <MUI.ButtonIcon onClick={this.openDialog}>
                <Icons.MoreHoriz />
              </MUI.ButtonIcon>
            </MUI.Tooltip>
          </Card.HeaderAction>
        </Card.Header>

        <Card.Content scroll>
          {newsData.map((news, index) => {
            return (
              <BoxRow key={index}>
                <NewsBox>
                  <MUI.Box width="75%">
                    <Typography.H6>{news.Titulo}</Typography.H6>
                  </MUI.Box>
                  <MUI.Box width="25%">
                    <NewsDate>
                      <Typography.Small>{moment(news.FechaInicio).format('DD/MM/YYYY')}</Typography.Small>
                    </NewsDate>
                  </MUI.Box>
                </NewsBox>
                <MUI.Box>
                  <Typography.Text>{news.Mensaje}</Typography.Text>
                </MUI.Box>
              </BoxRow>
            );
          })}
          {/* News Not Found */}
          {newsData.length === 0 && (
            <BoxNotFound>
              <Icons.Info />
              <Typography.H6>{`${i18n.t('News.noNews')}`}</Typography.H6>
            </BoxNotFound>
          )}
        </Card.Content>

        {/* News Dialog */}
        {this.state.open && (
          <NewsDialog
            open={open}
            news={newsData}
            filters={filters}
            onClose={this.closeDialog}
            onFilter={this.filterNews}
            onClickRow={this.clickRow}
          />
        )}
      </>
    );
  }
}

// *************************************
// STYLED COMPONENTS                               
// *************************************

const BoxRow = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
`;

const BoxNotFound = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;

  .MuiSvgIcon-root {
    margin-right: 12px;
    font-size: 20px;
  }
`;

const NewsBox = styled.div`
  display: flex;
  align-items: center;
`;

const NewsDate = styled(Typography.Text)`
  padding: 8px;
  color: ${(props) => props.theme.colors.blueMedium};
  align-self: center;
  text-align: end;
`;


export default News;